import React from 'react';
import PropTypes from 'prop-types';
import { Item } from 'semantic-ui-react';
const ClaimList = props => {
    return (
        <Item.Group divided>
            {props.children}
        </Item.Group>
    );
};

ClaimList.propTypes = {
    children: PropTypes.node,
};

export default ClaimList;